import React, { useEffect, useRef } from 'react';
import { Loader2 } from 'lucide-react';
import { authApi } from '@/Api/auth-v2.api';

/**
 * Page de déconnexion de l'outil pro.
 *
 * Invalide les tokens côté API, nettoie la session locale (AuthStore +
 * localStorage) puis renvoie vers /login. Le rechargement complet garantit
 * qu'aucun state applicatif ne survit à la déconnexion.
 */
export const LogoutPage: React.FC = () => {
  const hasRunRef = useRef(false);

  useEffect(() => {
    if (hasRunRef.current) return;
    hasRunRef.current = true;

    (async () => {
      try {
        await authApi.logout(); // invalide tokens API + clear AuthStore/localStorage
      } catch {
        // authApi.logout() gère déjà ses erreurs, on force le clean local si besoin
      }

      window.location.replace('/login');
    })();
  }, []);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Loader2 className="animate-spin" size={32} />
      <span style={{ marginLeft: 12 }}>Déconnexion en cours…</span>
    </div>
  );
};

export default LogoutPage;
